<template>
    <div class="business">
        <MobileNav/>
        <div class="info-title" >
            <span>公司服务</span>
        </div>
        <div class="list" v-if='ifYg'>
            <div><router-link to="/server">服务器</router-link></div>
        </div>
    </div>
</template>

<script>
import MobileNav from '../components/MobileNav'
export default {
    components:{
      MobileNav
    },
    computed:{
      mode(){
        return this.$store.state.mode;
      },
      ifYg() {
        return this.$store.state.ifYg
      }
    },
}
</script>
<style lang="less" scoped>
.business{
    .info-title{
        padding-top: 2vh;
        text-align: center;
        span{
          display:inline-block;
          text-align:center;
          color:#fff;
          width: 80vw;
          font-size: 18px;
        }
        margin-bottom: 4vh;
        line-height: 5vh;
    }
    .list{
        width: 80vw;
        height: 70vh;
        position: relative;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        margin: auto;
        padding-top: 20vh; 
        div{
            width: 100%;
            margin: 2vh 0;
            border-radius: 5vh;
            box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
            background: linear-gradient( to top right, #313a46 20%,#444e58 80%);//正常
            a{
                color: #fff;
                text-decoration: none;
                font-size: 16px;
                display: inline-block;
                width: 100%;
                padding: 2vh 0;
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/pages/company.vue